import { useLocation } from "react-router-dom";

function EventsDisplay({ data }) {
const location = useLocation();
const isEventsPage = location.pathname === "/events";
const isMyEventsPage = location.pathname === "/my-events";
const pageTitle = isMyEventsPage ? "My Events" : isEventsPage ? "Events" : "All Events";

  const Clock = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
      <path d="M0 0h24v24H0z" fill="none" />
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
        <circle cx="12" cy="12" r="10" />
        <path d="m15 16l-2.414-2.414A2 2 0 0 1 12 12.172V6" />
      </g>
    </svg>

  );

  const Location = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
      <path d="M0 0h24v24H0z" fill="none" />
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
        <circle cx="12" cy="10" r="3" />
        <path d="M12 2a8 8 0 0 0-8 8c0 1.892.402 3.13 1.5 4.5L12 22l6.5-7.5c1.098-1.37 1.5-2.608 1.5-4.5a8 8 0 0 0-8-8" />
      </g>
    </svg>

  );

  if (!data) return null; // handle undefined data

  return (
    <>
      <div className="service2-section mb-100">
        <div className="container">
          <div className="section-title2 primary3" data-aos="fade-up">
            <span>Blog Event</span>
            <h2>{pageTitle}</h2>
          </div>
          <div className="service-items-wrap g-4 row" data-aos="fade-up">  
              {data?.length > 0 &&
                data.map((each, i) => {
                   const [day, month, year] = each.display_event_date.trim().split(" ");
                  return (
                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                    <div className='service-semi-wrap' key={each.id || i} >
                      <div className="glass-effect overflow-hidden space" >
                        <div className="event-item-details">
                          <div className='event-icons'>
                              <p className="event-date">
                                <span className="date dates">{day}</span>
                                <span className="month dates">{month?.slice(0, 3)}</span>
                                <span className="year dates">{year}</span>
                              </p>
                            <div className='time'>
                              <Clock />&nbsp;{each.event_start_time}-
                              <span>{each.event_end_time}</span>
                            </div>
                          </div>
                          {/* <div className="event-image">
                            <img src={EventImage} alt="event-image" className="img-fluid" />
                          </div> */}
                           <div className="service-content">
                            <p className='venue'><Location />&nbsp;{each.venue_name}</p>
                            <h3>{each.event_name}</h3>
                            <p className="para">{each.short_description}</p>
                            {/* <div className='attendees'>Attendees: <span>{each.attendee_limit}</span></div> */}
                          </div>
                          </div>
                      </div>
                    </div>
              </div> 
                  );
                })}
          </div>
        </div>
      </div>
    </>
  );
}

export default EventsDisplay;